import React from 'react';
import { prop } from 'ramda';

import { CookiesRegulationMessage } from '@interlayer/js/components/main/CookiesRegulationMessage/CookiesRegulationMessage';
import { StickyMenuContainer } from '@interlayer/js/custom/components/hub2/StickyMenu/components/StickyMenuContainer';

import { LAYER_POSITION } from '@core/js/components/system/Router/constants';
import { useDeviceSelector } from '@core/js/store/hooks';

import styles from './StickyBottomContainer.scss';

type Props = {
    layerPosition: LAYER_POSITION;
}

export const StickyBottomContainer: React.FC<Props> = ({ layerPosition }) => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    return (
        <div className={styles.container}>
            {layerPosition === LAYER_POSITION.BOTTOM && (
                <CookiesRegulationMessage />
            )}

            {!isDesktop && <StickyMenuContainer />}
        </div>
    );
};
